import React from "react";

export const HelpLogo = ({
  width = "30",
  height = "30",
  fill = "none",
  color = "white",
}) => (
  <svg
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginTop: "5px" }}
  >
    <path
      d="M2.08337 10.0002C2.08337 6.26821 2.08337 4.40224 3.24274 3.24286C4.40212 2.0835 6.26809 2.0835 10 2.0835C13.732 2.0835 15.598 2.0835 16.7574 3.24286C17.9167 4.40224 17.9167 6.26821 17.9167 10.0002C17.9167 13.7321 17.9167 15.5981 16.7574 16.7575C15.598 17.9168 13.732 17.9168 10 17.9168C6.26809 17.9168 4.40212 17.9168 3.24274 16.7575C2.08337 15.5981 2.08337 13.7321 2.08337 10.0002Z"
      stroke={color}
      stroke-opacity="0.6"
      stroke-width="1.25"
    />
    <path
      d="M8.33337 7.50016C8.33337 6.57969 9.07954 5.8335 10 5.8335C10.9205 5.8335 11.6667 6.57969 11.6667 7.50016C11.6667 7.83195 11.5698 8.1411 11.4026 8.40083C10.9045 9.17491 10 9.913 10 10.8335V11.2502"
      stroke={color}
      stroke-opacity="0.6"
      stroke-width="1.25"
      stroke-linecap="round"
    />
    <path
      d="M9.99341 14.167H10.0009"
      stroke={color}
      stroke-opacity="0.6"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
